@if (data | async; as data) {
  @if(userdata && !isSubmitted && !userdata?.confirmedOrder && !errormessage && !userdata?.provisionalOrderFormLinkExpired){
  <div class="user_form_Container">
    <div class="form_Header">{{data.headline}}</div>
    <div class="preebook_Outercontainer">
      <div class="customer_Form_Container">
        <div class="customer_Form_Heading">{{"prebookform.formheading1" | cxTranslate}}</div>
        <div class="customer_Details">
         <!--  @if(seqiruscontact?.name){
           <div class="customer_Name">{{seqiruscontact?.name}}</div>
          } -->
          @if(seqiruscontact?.phone){
           <div class="customer_Phno margin-T5">{{seqiruscontact?.phone}}</div>
          }
          @if(seqiruscontact?.email){
           <div class="customer_Email">{{seqiruscontact?.email}}</div>
          }
        </div>
      </div>
      <div class="form_Container">
        <div class="form_Heading">{{"prebookform.formheading2" | cxTranslate}}</div>
        <div class="section_Row">
          <div class="section_Container">
            <!--Invoice address-->
            <div class="section_Heading">{{"prebookform.sectionheading1" | cxTranslate}}</div>
            <div class="section_Form">
              @if(userdata?.reviewData?.soldToID){
                <div class="input-group">
                  <label>{{"prebookform.accountnumber" | cxTranslate}}</label>
                  <input readonly value="{{userdata?.reviewData?.soldToID}}">
                </div>
              }
              @if(invoiceaddress?.locname){
                <div class="input-group">
                  <label>{{"prebookform.accountname" | cxTranslate}}</label>
                  <input readonly value="{{invoiceaddress?.locname}}">
                </div>
              }
              @if(invoiceaddress?.addressLine1){
                <div class="input-group">
                  <label>{{"prebookform.address1" | cxTranslate}}</label>
                  <input readonly value="{{invoiceaddress?.addressLine1}}">
                </div>
              }
              @if(invoiceaddress?.addressLine2){
                <div class="input-group">
                  <label>{{"prebookform.address2" | cxTranslate}}</label>
                  <input readonly value="{{invoiceaddress?.addressLine2}}">
                </div>
              }
              @if(invoiceaddress?.zip){
                <div class="input-group">
                  <label>{{"prebookform.postcode" | cxTranslate}}</label>
                  <input readonly value="{{invoiceaddress?.zip}}">
                </div>
              }
            </div>
          </div>
          <!--Delivery container-->
          <div class="section_Container">
            <div class="section_Heading">{{"prebookform.sectionheading2" | cxTranslate}}</div>
            <div class="section_Form">
              @if(userdata?.reviewData?.soldToID){
                <div class="input-group">
                  <label>{{"prebookform.accountnumber" | cxTranslate}}</label>
                  <input readonly value="{{userdata?.reviewData?.soldToID}}">
                </div>
              }
              @if(deliveryaddress?.locname){
                <div class="input-group">
                  <label>{{"prebookform.accountname" | cxTranslate}}</label>
                  <input readonly value="{{deliveryaddress?.locname}}">
                </div>
              }
              @if(deliveryaddress?.addressLine1){
                <div class="input-group">
                  <label>{{"prebookform.address1" | cxTranslate}}</label>
                  <input readonly value="{{deliveryaddress?.addressLine1}}">
                </div>
              }
              @if(deliveryaddress?.addressLine2){
                <div class="input-group">
                  <label>{{"prebookform.address2" | cxTranslate}}</label>
                  <input readonly value="{{deliveryaddress?.addressLine2}}">
                </div>
              }
              @if(deliveryaddress?.zip){
                <div class="input-group">
                  <label>{{"prebookform.postcode" | cxTranslate}}</label>
                  <input readonly value="{{deliveryaddress?.zip}}">
                </div>
              }
              @if(licenseNumbers && licensename){
                <div class="input-group">
                  <label>{{"prebookform.registration" | cxTranslate}}</label>
                  <input readonly value="{{licensename}} - {{licenseNumbers}}" class="gmc_Label">
                </div>
              }
          <!--     @if(deliveryaddress?.nhscode){
                <div class="input-group">
                  <label>{{"prebookform.practicecode" | cxTranslate}}</label>
                  <input readonly value="{{deliveryaddress?.nhscode}}">
                </div>
              } -->
            </div>
          </div>
        </div>
      </div>
      <div class="form_Container">
        <div class="form_Heading">{{"prebookform.formheading4"| cxTranslate}}</div>
        <div class="section_Row section_Inv_Row">
          <div class="section_Container">
            <div class="section_Heading">{{"prebookform.sectionheading3" | cxTranslate}}</div>
            <!--sales contact-->
            <div class="section_Form">
              @if(salescontact?.name){
                <div class="input-group">
                  <label>{{"prebookform.name" | cxTranslate}}</label>
                  <input readonly value="{{salescontact?.name}}">
                </div>
              }
              @if(salescontact?.email){
                <div class="input-group">
                  <label>{{"prebookform.email" | cxTranslate}}</label>
                  <input readonly value="{{salescontact?.email}}">
                </div>
              }
              @if(salescontact?.phone){
                <div class="input-group">
                  <label>{{"prebookform.telephone" | cxTranslate}}</label>
                  <input readonly value="{{salescontact?.phone}}">
                </div>
              }
            </div>
            @if(userdata?.reviewData?.invoiceEmail){
              <div class="section_Heading sub_Section_Heading desktop_Section_Heading">
                {{"prebookform.sectionheading4" | cxTranslate}}</div>
            }
            <!--Invoice contact-->
              <div class="section_Form desktop_Section_Form">
                @if(userdata?.reviewData?.invoiceEmail){
                  <div class="input-group">
                    <label>{{"prebookform.name" | cxTranslate}}</label>
                    <input readonly value="{{userdata?.reviewData?.invoiceEmail}}">
                  </div>
                }
              </div>
          </div>
          <div class="section_Container">
            <div class="section_Heading">{{"prebookform.sectionheading5" | cxTranslate}}</div>
            <div class="section_Form">
              @if(deliverycontact?.[0]?.name){
              <div class="input-group">
                <label>{{"prebookform.name" | cxTranslate}}</label>
                <input readonly value="{{deliverycontact?.[0]?.name}}">
              </div>
              }
              @if(deliverycontact?.[0]?.email){
              <div class="input-group">
                <label>{{"prebookform.email" | cxTranslate}}</label>
                <input readonly value="{{deliverycontact?.[0]?.email}}">
              </div>
              }
              @if(deliverycontact?.[0]?.phone){
              <div class="input-group">
                <label>{{"prebookform.telephone" | cxTranslate}}</label>
                <input readonly value="{{deliverycontact?.[0]?.phone}}">
              </div>
              }
            </div>
            @if(userdata?.reviewData?.statementEmail){
              <div class="section_Heading sub_Section_Heading desktop_Section_Heading">{{"prebookform.sectionheading6" | cxTranslate}}
              </div>
            }
            <div class="section_Form desktop_Section_Form">
              <!--Statement contact-->
              @if(userdata?.reviewData?.statementEmail){
                <div class="input-group">
                  <label>{{"prebookform.name" | cxTranslate}}</label>
                  <input readonly value="{{userdata?.reviewData?.statementEmail}}">
                </div>
              }
            </div>
          </div>
          <div class="section_Container mobile_Section_Container">
            <!--mobile invoice and statemnet contact section-->
            @if(userdata?.reviewData?.invoiceEmail){
              <div class="section_Heading  mobile_Section_Heading">
                {{"prebookform.sectionheading4" | cxTranslate}}</div>
            }
            <!--Invoice contact-->
            <div class="section_Form mobile_Section_Form">
              @if(userdata?.reviewData?.invoiceEmail){
                <div class="input-group">
                  <label>{{"prebookform.name" | cxTranslate}}</label>
                  <input readonly value="{{userdata?.reviewData?.invoiceEmail}}">
                </div>
                }
            </div>
          </div>
          <div class="section_Container mobile_Section_Container">
            <!--mobile invoice and statemnet contact section-->
            @if(userdata?.reviewData?.statementEmail){
              <div class="section_Heading mobile_Section_Heading">
                {{"prebookform.sectionheading6" | cxTranslate}}
              </div>
            }
            <div class="section_Form mobile_Section_Form">
              <!--Statement contact-->
              @if(userdata?.reviewData?.statementEmail){
                <div class="input-group">
                  <label>{{"prebookform.name" | cxTranslate}}</label>
                  <input readonly value="{{userdata?.reviewData?.statementEmail}}">
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="form_Container">
        <div class="form_Heading">{{"prebookform.formheading5"| cxTranslate}}</div>
        <div class="product_Container">
          <div class="row">
            <div class="col-xs-12 no-padding">
              <div class="product_Container_Box">
                <div class="table-wrapper desktop_Mobile_wrapper">
                  @for(prod of products; track prod){
                    <div>
                      <!-- Product Title -->
                      <div class="prod-title" [innerHTML]="prod?.displayName"></div>
                      <!-- Description -->
                      <div class="prod-desc" [innerHTML]="prod?.productDescription"></div>
                      <div class="year">2027</div>
                      <table class="deliverytable">
                        <!-- MONTH ROW -->
                        <tr>
                          <td class="deliverycol delivery_Date">Delivery Date*</td>
                          <td class="deliverycol1"></td>
                          @for(slot of prod.deliverySlots; track slot; let i = $index){
                            <td class="delivery_Month">{{ slot?.month }}</td>
                            @if(i === maxDeliverySlots){
                            <td class="gapbet"></td>
                            }
                          }
                          <td class="gapdose"></td>
                          <td class="dosestext doses_Txt">Doses</td>
                        </tr>
                        <!-- DATE ROW -->
                        <tr>
                          <td class="deliverycol wk_Commencing">(wk. commencing)</td>
                          <td class="deliverycol1"></td>
                          @for (slot of prod?.deliverySlots; track slot; let i = $index) {
                              <td class="prod_Delivery_Date">{{ slot?.date }}</td>
                              @if(i === maxDeliverySlots){
                              <td class="gapbet"></td>
                              }
                          }
                          <td class="gapdose"></td>
                          <td class="dosestext ordered_Txt">Ordered</td>
                          <td>
                        </tr>
                        <!-- QUANTITY ROW -->
                        <tr>
                          <td class="deliverycol prod_Name" [innerHTML]="prod?.productLabel"></td>
                          <td class="deliverycol1"></td>
                          @for(slot of prod?.deliverySlots; track slot; let i = $index){
                            <td class="delivery_Quantity">
                              <input type="text" class="dose-input" 
                              [value]="slot?.quantity ? (slot.quantity | number) : ''" 
                              readonly />
                            </td>
                            @if(i === maxDeliverySlots){
                            <td class="gapbet"></td>
                            }
                          }
                          <td class="gapdose"></td>
                          <!-- TOTAL -->
                          <td class="total">
                            <input type="text" class="dose-input" [value]="prod?.qty | number" readonly />
                          </td>
                        </tr>
                      </table>
                    </div>
                  }
                </div>
                <!-- MOBILE VIEW -->
                @for(prod of products; track prod){
                  <div class="mobile-view">
                    <!-- Product Title -->
                    <div class="prod-title" [innerHTML]="prod?.displayName"></div>
                    <!-- <div class="prod-title">TIVc (IIVc) (PLGB 47991/0015)</div> -->
                    <!-- Description -->
                    <div class="mobile_Outer_Container">
                      <div class="prod-desc" [innerHTML]="prod?.productDescription"></div>
                      <div class="mobile_Product_Section">
                        <div class="mobile-header">
                          <div class="mobile_Delivery_Date">
                            <div class="mobile-year">2027</div>
                            <div class="mobile-deliver-text">Delivery Date*</div>
                            <div class="mobile-commencing">(wk. commencing)</div>
                          </div>
                          <div class="mobile_product_Name" [innerHTML]="prod?.productLabel"></div>
                        </div>
                        <!-- DELIVERY LIST -->
                        <div class="mobile_product_Container">
                          @for(slot of prod?.deliverySlots; track slot; let i = $index){                        
                            <div class="mobile-row">
                              <div class="mobile-date">
                                {{ slot?.month }} {{ slot?.date }}
                              </div>
                              <div class="mobile-input">
                                <input type="text" class="dose-input"
                                  [value]="slot?.quantity ? (slot.quantity | number) : ''" 
                                  readonly />
                              </div>
                            </div>
                            @if(i === maxDeliverySlots){
                            <div class="gapbet"></div>
                            }
                          }
                        </div>
                        <!-- TOTAL -->
                        <div class="mobile-total">
                          <span class="mobile_Doses">Doses Ordered</span>
                          <input type="text" class="dose-input" [value]="prod?.qty | number" 
                          readonly />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="prod_Text_Container">
            <div class="prod_Txt1">{{data?.content}}</div>
            <div class="prod_Txt2">{{data?.largeparagraphcontent}}</div>
          </div>
        </div>
      </div>
      <div class="approval_form_Container">
        <div class="approval_Heading">{{"prebookform.approval" | cxTranslate}}</div>
        <div class="approval_Section_Container">
          <div class="form_Section_Row">
            <div class="approval_SubHead">{{data.paragraphcontent}}</div>
            <form [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="customerForm">
              <div class="form_Input_Section">
                <div class="input-group">
                  <label for="name" [innerHTML]="'prebookform.approvalname' | cxTranslate"></label>
                  <input id="name" type="text" formControlName="name">
                </div>
                <div class="input-group">
                  <label for="position" [innerHTML]="'prebookform.position' | cxTranslate"></label>
                  <input id="position" type="text" formControlName="position">
                </div>
              </div>
              <button type="submit" [disabled]="!customerForm.valid"
                class="submit_Form">{{"prebookform.confirmbutton"|cxTranslate}}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="preebook_Jbgcode" [innerHTML]="data.jobCode"></div>
  </div>
  }
}
<!-- Thank You Screen -->
@if(data | async; as data){
  @if(isSubmitted && !errormessage){
    <div class="thankyou_Container">
      <div class="thankyou_Box">
        <div class="thankyou_Message" [innerHTML]="data?.h3content"></div>
        <div>
          <a routerLink="/homepage" class="login_Btn">Log In</a>
        </div>
      </div>
      <div class="preebook_Jbgcode" [innerHTML]="data?.jobCode"></div>
    </div>
  }
}
<!--already confirmed message-->
@if(data | async; as data){
  @if(!isSubmitted && userdata?.confirmedOrder){
    <div class="already_Confirmed_Box">
      <div class="confirm_Container">
        <div class="confrim_Txt" [innerHTML]="data?.h2content"></div>
        <div>
          <a routerLink="/homepage" class="login_Btn">Log In</a>
        </div>
      </div>
      <div class="preebook_Jbgcode" [innerHTML]="data?.jobCode"></div>
    </div>
  }
}
<!--Error message-->
@if(data | async; as data){
  @if(errormessage){
    <div class="error_Msg_Box">
      <div class="error_Container">
        <div class="error_Txt">
          Something went wrong.
        </div>
        <div class="error_Sub_Txt">
          We’re sorry - it looks like this feature isn’t working right now. Please call us on <span class="tel_number">0845
            745 1500</span> for assistance.
        </div>
        <div>
          <a routerLink="/homepage" class="login_Btn">Log In</a>
        </div>
      </div>
      <div class="preebook_Jbgcode" [innerHTML]="data?.jobCode"></div>
    </div>
  }
}
<!--When link is expired-->
@if(data | async; as data){
  @if(userdata?.provisionalOrderFormLinkExpired){
    <div class="link_Expiry_Box">
      <div class="link_Expiry_Container">
        <ul>
          <li [innerHTML]="data.materialSubHeading"></li>
        </ul>
        <ul>
          <div [innerHTML]="data.urlLink"></div>
        </ul>
      </div>
      <div class="preebook_Jbgcode" [innerHTML]="data?.jobCode"></div>
    </div>
  }
}